import { render, staticRenderFns } from "./ClientInitialUserDelete.vue?vue&type=template&id=5c64018e"
import script from "./ClientInitialUserDelete.vue?vue&type=script&lang=js"
export * from "./ClientInitialUserDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports